import * as axios from 'axios/index';
import { doPost, doGet } from './Api';

export default class LifeInvestmentService {
  static async getDataFund(data, token) {
    const response = await doPost(
      `${process.env.REACT_APP_BASE_VIGP}/vigp/v1/policies/fund-data`,
      data
    );
    return response.data.data;
  }

    static async getDataFundTest(data) {
    const response = await doPost(
      `${process.env.REACT_APP_BASE_VIGP}/vigp/v1/policies/fund-data`,
      data
    );
    return response.data.data.data;
  }

  static async getCoverage(data) {
    const response = await doPost(
      `${process.env.REACT_APP_BASE_VIGP}/vigp/v1/policies/main-coverage`, data
    );
    return response.data.data;
  }

    static async getCoverageTest(data) {
    const response = await doPost(
      `${process.env.REACT_APP_BASE_VIGP}/vigp/v1/policies/main-coverage`, data
    );
    return response.data.data.data;
  }

  static async getEmitterGraph(token) {
    const response = await doGet(`${process.env.REACT_APP_BASE_VIGP}/vigp/v1/policies/emitter-graph`);

    return response.data.data.data;
  }

  static async getSectorGraph(token) {

    const response = await doGet(`${process.env.REACT_APP_BASE_VIGP}/vigp/v1/policies/sector-graph`);

    return response.data.data.data;
  }

  static async getInstrumentGraph(token) {

    const response = await doGet(`${process.env.REACT_APP_BASE_VIGP}/vigp/v1/policies/instrument-graph`);

    return response.data.data.data;
  }

  static async getQuoteEvolutionValue(token) {

    const response = await doGet(`${process.env.REACT_APP_BASE_VIGP}/vigp/v1/policies/quote-evolution-value`);

    return response.data.data.data;
  }

  static async getPoliciesVigp() {
    const response = await doGet(
      `${process.env.REACT_APP_BASE_VIGP}/vigp/v1/policies`
    );

    return response.data.data;
  }

  static async getFaqs(payload, token) {

    const response = await doGet(`${process.env.REACT_APP_BASE_VIGP}/vigp/v1/policies/faqs`);

    return response.data.data.data;

  }

  static async getPolicyDetail(payload) {
    const response = await doGet(
      `${process.env.REACT_APP_BASE_VIGP}/vigp/v1/policies/policy-detail?policyNumber=${payload.nroPoliza}&nrol=${payload.rol}`
    );


    return response.data.data;
  }

  static async getDownloadStatement(payload, token) {
    const response = await doPost(`${process.env.REACT_APP_BASE_VIGP}/vigp/v1/policies/get-account-statement`, payload);
    
    return response.data.data;
  }

  static async getDownloadPolicy(nroPolicy, idTokenCognito) {
    try {

      const response = await axios.get(`${process.env.REACT_APP_BASE_VIGP}/vigp/v1/policies/policy-kit?nroPoliza=${nroPolicy}`,
        {
          responseType: 'blob',
          headers: {
            Accept: 'application/pdf',
            Authorization: `Bearer ${idTokenCognito}`
          }
        }
      )

      return response.data

    } catch (error) {
      console.error('Error al obtener el PDF:', error);
      throw error;
    }
  }

  static async getDownloadCertificate(nroPolicy, idTokenCognito) {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BASE_VIGP}/vigp/v1/policies/certificate-insurance?nroPoliza=${nroPolicy}`,
        {
          responseType: 'blob',
          headers: {
            Accept: 'application/pdf',
            Authorization: `Bearer ${idTokenCognito}`
          }
        }
      );

      console.log(response);

      return response.data

    } catch (error) {
      console.error('Error al obtener el PDF:', error);
      throw error;
    }
  }
}
